"use strict";
// The one recursion over a RunnitNodeDef field tree.
//
// Before this file the same loop existed in ten places (five plain, five
// visibility-aware) and had started to disagree with itself. See PR #729.
//
// Uses isGroupNode / isFieldNode from ./types rather than raw `__rgroup` /
// `__rfield`, so a published API-v2 tree (`isGroup` / `isField` / `fieldKey`)
// walks correctly too. The hand-rolled copies this replaces were Firestore-only
// and returned nothing on an API-v2 tree.
//
// Deps-free per ADR-0005: this folder imports nothing outside itself, which is
// why the VISIBILITY-aware walker is not here. It needs
// isFieldVisibleAndEnabled -> getLogicOnFieldsFromField (lodash + the firebase
// types), so it lives in ../runnitNodes.ts next to the logic it depends on.
//
// Written without `?.` / `??`: web's webpack-4 parser reads the symlinked shared
// dist without transpiling it and cannot parse either operator.
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachLeafField = eachLeafField;
const types_1 = require("./types");
/**
 * Every leaf field in the tree, in field order, recursing through groups.
 *
 * Groups themselves are not returned; only the fields inside them. A null or
 * undefined `fields` at any level yields nothing rather than throwing, matching
 * what every copy this replaces did.
 */
function eachLeafField(fields) {
    const out = [];
    for (const entry of (fields || [])) {
        const node = entry;
        if (!node)
            continue;
        if ((0, types_1.isGroupNode)(node)) {
            const nested = eachLeafField(node.fields || []);
            for (const leaf of nested)
                out.push(leaf);
            continue;
        }
        if ((0, types_1.isFieldNode)(node))
            out.push(node);
    }
    return out;
}
